import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box } from "@mui/material";
// components
import StringUtil from "src/utils/StringUtil";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import MyEditor from "src/components/editor/MyEditor";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { getProductCategories } from "src/services/request";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import SupplierPriceList from "./SupplierPriceList";

const TABS = [{ label: "基本信息" }, { label: "规格库存" }, { label: "商品详情" }, { label: "物流设置" }];

export default function SupplierProductEdit({ open, item, action, onClose, onFinish }) {
  const categories = useSelector((state) => state.globalData.productCategories) || [];
  const navigate = useNavigate();
  const { id } = item;
  const [category, setCategory] = useState({});

  const [detail, setDetail] = useState(item.detail);

  // console.log('categories', categories)

  const [tabIdx, setTabIdx] = useState("0");

  const [form, setForm] = useState({
    intro: item.intro || "",
    name: item.name || "",
    attrName: item.attrName || "",
    attrs: item.attrs || null,
    priceList: item.priceList || null,
    cover: item.cover || "",
    // coverHorizontal: item.coverHorizontal || "",
    images: item.images || "",
    detailImages: item.detailImages || "",
    categoryId: item.categoryId || 0, // 分类
    // priceOriginal: item.priceOriginal || "",
    price: item.price || "",
    // cost: item.cost || "",
    unit: item.unit || "件",
    shippingType: item.shippingType || 1,
    shippingFee: item.shippingFee || "",
    stock: item.stock || "",
    specType: item.specType || 0,
    // points: item.points || 0,
    // order: item.order || 0,
    // zhitui: item.zhitui || 0,
    // isRetail: item.isRetail != undefined ? item.isRetail : true,
    // isBulk: item.isBulk != undefined ? item.isBulk : false,
    // jiantui: item.jiantui || 0,
    // pointsMer: item.pointsMer || 0,
    // shares: item.shares || 0,
    // isBaodan: item.isBaodan || false,
    // directBuy: item.directBuy || false,
    // enableVip: item.enableVip || false,
    // sid: item.sid || 0,
  });

  useEffect(() => {
    getProductCategories();
  }, []);

  useEffect(() => {
    console.log(category, categories);
    if (!categories || !categories.length || !item.categoryId || category.id) return;
    setCategory(categories.find((c) => c.id == item.categoryId) || {});
  }, [categories]);

  // 选择框
  function handleSelect(type, event) {
    // console.log(type, event.target);
    if (type === "category") {
      setCategory(event.target.value);
      handleIptChange("categoryId", event.target.value.id);
    }
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handlePriceListChange(obj) {
    setForm({
      ...form,
      ...obj,
    });
  }

  async function handleSubmit() {
    const { specType, name, attrs, priceList } = form;
    if (!name) return alert("商品名称不能为空");
    if (!detail || !name) return alert("商品详情不能为空");
    if (specType && !attrs) return alert("多规格需添加规则");

    const formData = {
      ...form,
      detail,
      attrs: specType === 1 ? StringUtil.serialize(attrs) : null,
      priceList: specType === 1 ? StringUtil.serialize(priceList) : null,
    };

    // console.log(form);

    if (action == 'edit') {
      formData.id = id;
    }

    await asyncRequest({
      path: action == 'edit' ? "/store/product/edit" : "/store/product/add",
      data: formData,
    });

    onFinish();
  }

  return (
    <FormDialog open={open} title={`${action == 'edit' ? "编辑" : "添加"}商品`} onClose={onClose} onConfirm={handleSubmit} contentStyle={{width: '66vw', minWidth: '375px', height: '80vh'}}>
      <TabContext value={tabIdx}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={(e, idx) => setTabIdx(idx)}>
            {TABS.map((t, idx) => (
              <Tab key={t.label} label={t.label} value={String(idx)} />
            ))}
          </TabList>
        </Box>
        <TabPanel value="0">
        
          <FormItem title="商品分类">
            <Select value={category} onChange={(e) => handleSelect("category", e)} style={{ width: 250, height: 44 }}>
              {categories.map((category, idx) => (
                <MenuItem key={category.id} value={category} name={category.name}>
                  {Array(category.level - 1)
                    .fill("")
                    .map((_) => `|----`)
                    .join("")}
                  {category.name}
                </MenuItem>
              ))}
            </Select>
          </FormItem>

          <FormItem title="商品名称" required>
            <TextField fullWidth placeholder="请输入商品名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
          </FormItem>

          <FormItem title="商品单位" required>
            <TextField fullWidth placeholder="请输入商品单位" autoComplete="off" id="unit" value={form.unit} size="small" onChange={(e) => handleIptChange("unit", e.target.value)} />
          </FormItem>

          <FormItem title="商品封面" required>
            <Stack>
              <Uploader images={form.cover} onUploaded={(val) => handleIptChange("cover", val)} />
              <Typography mt={2} fontSize={14} color="gray">
                建议尺寸：800x800
              </Typography>
            </Stack>
          </FormItem>

          <FormItem title="商品轮播图" required>
            <Stack>
              <Uploader multiple images={form.images} onUploaded={(val) => handleIptChange("images", val)} />
              <Typography mt={2} fontSize={14} color="gray">
                建议尺寸：800x800
              </Typography>
            </Stack>
          </FormItem>

          <FormItem title="商品详情图" required>
            <Stack>
              <Uploader multiple images={form.detailImages} onUploaded={(val) => handleIptChange("detailImages", val)} />
            </Stack>
          </FormItem>

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        <TabPanel value="1">
          <FormItem title="商品规格" required>
            <RadioGroup row name="row-radio-buttons-group" value={form.specType} onChange={(e) => handleIptChange("specType", parseInt(e.target.value))}>
              <FormControlLabel value={0} control={<Radio />} label="单规格" />
              <FormControlLabel value={1} control={<Radio />} label="多规格" />
            </RadioGroup>
          </FormItem>

          {form.specType === 0 && (
            <>
              {/* <FormItem title="商品原价">
                <TextField fullWidth type="number" placeholder="请输入商品原价" autoComplete="off" id="priceOriginal" value={form.priceOriginal} size="small" onChange={(e) => handleIptChange("priceOriginal", e.target.value)} />
              </FormItem>

              <FormItem title="商品成本价">
                <TextField fullWidth type="number" placeholder="请输入商品成本价" autoComplete="off" id="cost" value={form.cost} size="small" onChange={(e) => handleIptChange("cost", e.target.value)} />
              </FormItem> */}

              <FormItem title="供货价" required>
                <TextField fullWidth type="number" placeholder="请输入供货价" autoComplete="off" id="price" value={form.price} size="small" onChange={(e) => handleIptChange("price", e.target.value)} />
              </FormItem>

              <FormItem title="商品库存" required>
                <TextField fullWidth type="number" placeholder="请输入商品库存，不填则无限" autoComplete="off" id="stock" value={form.stock} size="small" onChange={(e) => handleIptChange("stock", e.target.value)} />
              </FormItem>
            </>
          )}

          {form.specType === 1 && (
            <FormItem title="选择规格" required>
              <SupplierPriceList defaultAttrName={form.attrName} defaultAttrs={form.attrs} defaultPriceList={form.priceList} onChange={handlePriceListChange} />
            </FormItem>
          )}

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        <TabPanel value="2">
          <MyEditor
            html={detail}
            onChange={(val) => {
              setDetail(val);
            }}
          />

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        {/* 运费设置 */}
        <TabPanel value="3">
          <FormItem title="运费设置" required>
            <RadioGroup row name="row-radio-buttons-group" value={form.shippingType} onChange={(e) => handleIptChange("shippingType", parseInt(e.target.value))}>
              <FormControlLabel value={1} control={<Radio />} label="包邮" />
              <FormControlLabel value={2} control={<Radio />} label="固定邮费" />
            </RadioGroup>
          </FormItem>

          {form.shippingType == 2 && (
            <FormItem title="">
              <TextField fullWidth placeholder="请输入固定邮费" autoComplete="off" id="shippingFee" value={form.shippingFee} size="small" onChange={(e) => handleIptChange("shippingFee", e.target.value)} />
            </FormItem>
          )}

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

      </TabContext>
    </FormDialog>
  );
}
